<template>
  <v-layout row wrap>
    <v-flex xs12 md8>
      <h2 class="display-1 mb-3">Approval users</h2>
    </v-flex>
    <v-flex xs12 md12>
      <router-view></router-view>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    name: 'approver'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/mobile-user/Approver.vue